/**
 * Builds a configuration tab for customizing modal dialog properties such as title,
 * button labels, size, and layout options within a form editor.
 *
 * @param {WidgetProps<any, any>} props - The widget properties provided in the editor context.
 * @param {object} [params] - Optional customization parameters.
 * @param {DefaultFormWidgetConfigTypes[]} [params.children] - Additional widget components to include in the modal tab.
 * @param {(data: any) => any} [params.onLoad] - Optional hook to transform form data when the modal tab is loaded.
 * @param {(data: any) => any} [params.onSubmit] - Optional hook to transform form data before submission.
 * @returns {EditorTab} The constructed EditorTab object representing the modal configuration tab.
 */
export function buildModalTab(props, params) {
    var _a;
    const children = [
        {
            type: 'form.text',
            key: 'modal.title',
            label: 'Modal Title',
            description: 'By default modal title is the same as label',
            emptyAsNull: true,
        },
        {
            type: 'form.text',
            key: 'modal.cancelButtonLabel',
            label: 'Cancel Button Label',
            description: 'Default: Cancel',
            emptyAsNull: true,
        },
        {
            type: 'form.text',
            key: 'modal.saveButtonLabel',
            label: 'Save Button Label',
            description: 'Default: Save',
            emptyAsNull: true,
        },
        {
            type: 'form.select',
            key: 'modal.maxWidth',
            label: 'Max Width',
            values: [
                { value: 'xs', label: 'Extra Small' },
                { value: 'sm', label: 'Small' },
                { value: 'md', label: 'Medium' },
                { value: 'lg', label: 'Large' },
                { value: 'xl', label: 'Extra Large' },
                { value: 'full', label: 'Full' },
            ],
            style: {
                width: 200,
            },
        },
        {
            type: 'form.checkbox',
            key: 'modal.fullWidth',
            label: 'Full Width',
        },
        ...((_a = params === null || params === void 0 ? void 0 : params.children) !== null && _a !== void 0 ? _a : []),
    ];
    const onLoad = (data) => {
        if (params === null || params === void 0 ? void 0 : params.onLoad) {
            data = params.onLoad(data);
        }
        return data;
    };
    const onSubmit = (data) => {
        if (params === null || params === void 0 ? void 0 : params.onSubmit) {
            data = params.onSubmit(data);
        }
        return data;
    };
    return { label: 'Modal', children, onLoad, onSubmit };
}
